import { render } from "./OptionsRevenue.vue?vue&type=template&id=7681b732"
import script from "./OptionsRevenue.vue?vue&type=script&lang=js"
export * from "./OptionsRevenue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__